import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Filter } from '../filter';

export interface FilterConfigDelegate {
  createFilterConfig(filters: Filter[]): void;
  updateFilterConfig(name: string, filters: Filter[]): void;
  deleteFilterConfig(name: string): void;
  clearAllFilters(filters: Filter[]): void;
  removeActiveFilter(filter: Filter): void;
  // applyFilterConfig was removed from this delegate: it is only invoked by mosaic-gallery's
  // own template, and applying a saved config now takes the domain FilterCriterion[] (not the
  // UI Filter[]). Keeping it here would force @shared/ui to depend on @analysis/domain.
  // applyFilterConfig(configId: string, filters: Filter[]): void;
}

@Component({
    selector: 'ts-active-filters',
    templateUrl: './active-filters.component.html',
    styleUrls: ['./active-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActiveFiltersComponent {
  @Input() public filterConfigName?: string;
  @Input() public filters: Filter[] = [];
  @Input() public readonly delegate: FilterConfigDelegate;
}
